import shortid from 'shortid';
import find from 'lodash/find';
import findIndex from 'lodash/findIndex';
import cloneDeep from 'lodash/cloneDeep';
import maxBy from 'lodash/maxBy';
import sum from 'lodash/sum';
import isEqual from 'lodash/isEqual';
import difference from 'utils/difference';
import { put, fork, take, select, race } from 'redux-saga/effects';
import { takeFetch } from 'redux/helpers';
import * as serviceActions from '../../../../services/actions';
import * as actions from './actions';
import currentCategory from './currentCategory/saga';


function* upsertCategory() {
  const { success } = yield takeFetch(serviceActions.api.configuration.project.UPSERT_CATEGORY);
  if (success) {
    let {colors, itemOptions, primaryRoleOptions,secondaryRoleOptions, categories, categoryOptions, currentCategory: selectedCategory } = yield select(state => state.configuration.project.editor.category);
   
    selectedCategory.value.id = success.data.id;
    selectedCategory.added = false;

    let ind = categoryOptions.findIndex(x=> x.$$localId == selectedCategory.$$localId);
    categories[ind] = selectedCategory.value;

    categoryOptions = categoryOptions.sort((a, b) => a.value.order - b.value.order);
   
    if(selectedCategory.value.isRemoved)
    {
      categoryOptions = categoryOptions.filter(x => x.$$localId !== selectedCategory.$$localId);
      categories = categories.filter(x => x.name !== selectedCategory.value.name);
    }

    let selectedOption = categoryOptions.find(x=> x.$$localId == selectedCategory.$$localId);
    if(selectedOption)
    {
      selectedOption.changes = 0
      selectedOption.value.id = success.data.id;
      selectedOption.added = false;
    }
   
    yield put(actions.init.end({ categoryOptions, colors, itemOptions, primaryRoleOptions,secondaryRoleOptions, categories }));
    const option = selectedOption || categoryOptions[0];
    const localId = option && option.$$localId;
    yield put(actions.currentCategory.init.begin(localId));
    
    
    //yield put(actions.init.begin({ projectId, selectedCategoryName }));
    ttb.Notifications.ShowSaveSuccessMessage('Project Configuration', 'All the changes have been saved');
  } else {
    ttb.Notifications.ShowErrorMessage('Project Configuration', 'The changes have not been saved');
  }
}

function* getCategories({ selectedCategoryName }) {
  const { success } = yield takeFetch(serviceActions.api.configuration.project.GET_CATEGORIES);
  if (success) {
    const { categories: apiCategories, colors, itemOptions, primaryRoleOptions,secondaryRoleOptions } = success.data;
    let categoryOptions;
    let categories;
    let selectedOption;
    categories = apiCategories.sort((a, b) => a.order - b.order);
    categoryOptions = apiCategories.map(createCategoryOption);
    if(selectedCategoryName)
    {
      selectedOption = find(categoryOptions, x => x.value.name === selectedCategoryName)
    }
    yield put(actions.init.end({ categoryOptions, colors, itemOptions, primaryRoleOptions,secondaryRoleOptions, categories }));
    const option = selectedOption || categoryOptions[0];
    const localId = option && option.$$localId;
    yield put(actions.currentCategory.init.begin(localId));
  }
}

function createCategoryOption(category) {
  return {
    value: cloneDeep(category),
    $$localId: shortid.generate(),
    changes: 0,
  };
}

function* init() {
  while (true) {
    const { projectId, selectedCategoryName } = yield take(actions.INIT.BEGIN);
    yield put(serviceActions.api.configuration.project.getCategories.request({
      projectId,
    }));
    yield fork(getCategories, { selectedCategoryName });
  }
}

function* save() {
  while (true) {
    yield take(actions.SAVE.BEGIN);
    yield put(actions.currentCategory.checkValidation.begin());
    const { errors } = yield take(actions.currentCategory.CHECK_VALIDATION.END);
    if(!errors) {
      const {
        projectId,
        currentCategory: selectedCategory,
      } = yield select(state => state.configuration.project.editor.category);
      yield fork(upsertCategory);
      yield put(serviceActions.api.configuration.project.upsertCategory.request({
        projectId,
        category: selectedCategory.value,
      }));
    }
  }
}

function* add() {
  while (true) {
    yield take(actions.ADD.BEGIN);
    const { categoryOptions: previosCategories } = yield select(state => state.configuration.project.editor.category);
    const maxOrderCategory = maxBy(previosCategories, x => x.value.order);
    const order = maxOrderCategory ? maxOrderCategory.value.order + 1 : 1;
    const localId = shortid.generate();
    const categoryOptions = [
      ...previosCategories,
      {
        $$localId: localId,
        added: true,
        value: {
          order,
          name: `New Category ${previosCategories.length + 1}`,
          color: 0,
          items: [],
          roles: [],
          logSpentTime: true,
          complexity: 1
        },
      },
    ];
    yield put(actions.add.end({ categoryOptions }));
    yield put(actions.currentCategory.init.begin(localId));
  }
}

function* remove() {
  while (true) {
    const { localId } = yield take(actions.REMOVE.BEGIN);
    const { categoryOptions: previosCategories } = yield select(state => state.configuration.project.editor.category);
    const categoryOptions = previosCategories.filter(x => x.$$localId !== localId);
    yield put(actions.remove.end({ categoryOptions }));
    yield put(actions.currentCategory.init.begin(categoryOptions[categoryOptions.length - 1] && categoryOptions[categoryOptions.length - 1].$$localId));
  }
}

function* invalidate() {
  while (true) {
    yield race([
      take(actions.currentCategory.SET_NAME),
      take(actions.currentCategory.SET_COLOR),
      take(actions.currentCategory.SET_ORDER),
      take(actions.currentCategory.SET_IS_ACTIVE),
      take(actions.currentCategory.SET_ITEMS),
      take(actions.currentCategory.SET_ROLES),
      take(actions.currentCategory.SET_ROLES_SECONDARY),
      take(actions.currentCategory.SET_REMOVED),
      take(actions.currentCategory.RESET_CHANGES.END),
      take(actions.currentCategory.SET_LOG_SPENT_TIME),
      take(actions.currentCategory.SET_COMPLEXITY),
      take(actions.currentCategory.SET_DEPENDENCIES),
      take(actions.currentCategory.SET_FORECAST_PREFIX),
      take(actions.ADD.END),
      take(actions.REMOVE.END),
    ]);
    const {
      categories,
      categoryOptions: previosCategories,
      currentCategory: selectedCategory,
       } = yield select(state => state.configuration.project.editor.category);
    const newCategories = previosCategories.map((x) => {
      const res = x.$$localId === selectedCategory.$$localId && !isEqual(x.value, selectedCategory.value)
        ? { ...selectedCategory }
        : x;
      const categoryValue = find(categories, y => y.id === res.value.id);
      const changes = categoryValue ? difference(res.value, categoryValue) : 1;
      return res.changes === changes ? res : {
        ...res,
        changes,
      };
    });
    const categoryOptions = isEqual(newCategories, previosCategories)
      ? previosCategories
      : newCategories;
    const allChanges = sum(categoryOptions.map(x => x.changes));
    yield put(actions.invalidate({ categoryOptions, changes: allChanges }));

    const newSelectedcategory = find(categoryOptions, x => x.$$localId === selectedCategory.$$localId);
    if (newSelectedcategory && newSelectedcategory.changes !== selectedCategory.changes) {
      yield put(actions.currentCategory.invalidateChanges({ changes: newSelectedcategory.changes }));
    }
  }
}


export default function* category() {
  yield fork(currentCategory);
  yield fork(init);
  yield fork(save);
  yield fork(add);
  yield fork(remove);
  yield fork(invalidate);
}



// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/category/saga.js